import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { isDemo, installDemo } from './demo/install.js';
import { handleServiceWorkerMessage } from './swMessages.js';
import './styles.css';

// Demo mode: install the synthetic-fleet fetch/WebSocket shims BEFORE anything
// (including useCapabilities) issues its first request. No-op in normal builds.
if (isDemo()) {
  installDemo();
}

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch((err) => console.warn('SW registration failed:', err));
  });

  // Push arrivals relay to the open app (swMessages.js).
  navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
